import {
  ACCOUNT_STATEMENT_ROUTE,
  AFFILIATE_PROGRAM_ROUTE,
  BONUS_STATEMENT_ROUTE,
  DEPOSIT_ROUTE,
  fetchBalance,
  HOME_ROUTE,
  IN_PLAY_ROUTE,
  LOGIN_ROUTE,
  logout,
  MY_BETS_ROUTE,
  MY_PROFILE_ROUTE,
  MY_TRANSACTION_ROUTE,
  MY_WALLET_ROUTE,
  PROFIT_LOSS_REPORT_ROUTE,
  RootState,
  STAKE_SETTINGS_ROUTE,
  TURNOVER_REPORT_ROUTE,
  useAppDispatch,
  useAppSelector,
  WITHDRAW_ROUTE,
  UserMenuEnum,
  getUsername,
  notDemoUser,
  getLangData,
  CURRENCY_TYPE_FACTOR,
  getCurrencyTypeFromToken,
  showToast,
} from "@hypexone/uicore";
import { useEffect, useRef, useState } from "react";
import { isDesktop, isMobile } from "react-device-detect";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UserIcon from "../../../assets/images/Casino_svg_img/User_Icon.svg";
import logo from "../../../assets/images/brand/title.png";
import { headerGradient } from "../../../utils/constants/common.constants";
import MenuComponent from "../shared/MenuComponent";
import NewsAndPromotions from "../shared/NewsAndPromotions";
import HeaderButtonComponent from "./HeaderButtonComponent";
import HeaderSearchInput from "./HeaderSearchInput";
import LoginButtons from "./LoginButtons";
import SubHeader from "./SubHeader";
import Modal from "../shared/ExpModal";
import Button from "../shared/Button/Button";
import Languages from "../user-menu-pages/Languages";
import AllOpenBets from "../user-menu-pages/OpenBets/AllOpenBets";
import SkinOptions from "./SkinOptions";
import SkinIcon from "../../../assets/icons/header-icons/skin-icon.svg";
import { ChevronDown, RefreshCw } from "lucide-react";
import { FaUser } from "react-icons/fa6";
import { FaInfoCircle } from "react-icons/fa";
import { getEnvVariable } from "../../../constants/brandConfig";
import { domain } from "../../../constants/Branding";
interface HeaderProps {
  disableSportsSubheader?: boolean;
  balance: number;
  exposure: number;
  loggedIn: boolean;
}

const Header: React.FC<HeaderProps> = ({
  disableSportsSubheader,
  balance,
  exposure,
  loggedIn,
}) => {
  const [showOpenBets, setShowOpenBets] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const pathName = useLocation().pathname;
  const [Balance, setBalance] = useState<string | number>(balance);
  const [Exposure, setExposure] = useState<string | number>(exposure);
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const [langSelected, setLangSelected] = useState<string>();
  const hasInplayInPath = pathName.includes(IN_PLAY_ROUTE);

  const navigate = useNavigate();
  const { domainConfig } = useAppSelector((state) => state.common);
  const balanceSummary = useAppSelector((state) => state.auth.balanceSummary);
  const openBets = useAppSelector((state) => state.betSlip.openBets) ?? [];
  const [showTooltip, setShowTooltip] = useState(false);
  const mobileTooltipRef = useRef<HTMLDivElement>(null);
  const cashableDisplay = (Number(balanceSummary?.cashableAmount / cFactor) ?? 0).toFixed(2);
  const nonCashableDisplay = domainConfig?.payments
    ? Math.max(
        Number(exposure / cFactor) || 0,
        (Number(balanceSummary?.nonCashableAmount / cFactor) || 0) + (Number(balanceSummary?.bonusRedeemed / cFactor) || 0)
      ).toFixed(2)
    : "0";

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [isSkinOpen, setIsSkinOpen] = useState(false);
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    if (!isMobile || !showTooltip) return;
    const handleClickOutside = (e: MouseEvent | TouchEvent) => {
      const el = mobileTooltipRef.current;
      if (el && !el.contains(e.target as Node)) setShowTooltip(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isMobile, showTooltip]);

  const userMenuList = [
    {
      title: UserMenuEnum.MY_PROFILE,
      navigationUrl: MY_PROFILE_ROUTE,
      enabled: true,
    },
    {
      title: "Claim Bonuses",
      navigationUrl: "/bonus_rewards",
      enabled: domainConfig.bonus && notDemoUser(),
    },
    { title: UserMenuEnum.HOME, navigationUrl: HOME_ROUTE },
    {
      title: UserMenuEnum.ACCOUNT_STATEMENT,
      navigationUrl: ACCOUNT_STATEMENT_ROUTE,
      enabled: true,
    },
    {
      title: UserMenuEnum.PROFIT_LOSS_REPORT,
      navigationUrl: PROFIT_LOSS_REPORT_ROUTE,
      enabled: true,
    },
    {
      title: UserMenuEnum.MY_WALLET,
      navigationUrl: MY_WALLET_ROUTE,
      enabled: true,
    },
    // {
    //   title: UserMenuEnum.TURNOVER_REPORT,
    //   navigationUrl: TURNOVER_REPORT_ROUTE,
    //   enabled: true,
    // },
    {
      title: UserMenuEnum.AFFILIATE_PROGRAM,
      navigationUrl: AFFILIATE_PROGRAM_ROUTE,
      enabled: domainConfig.affiliate && notDemoUser(),
    },
    {
      title: UserMenuEnum.TURNOVER_REPORT,
      navigationUrl: TURNOVER_REPORT_ROUTE,
      enabled: domainConfig.bonus && notDemoUser(),
    },
    {
      title: UserMenuEnum.BONUS_STATEMENT,
      navigationUrl: BONUS_STATEMENT_ROUTE,
      enabled: domainConfig.bonus && notDemoUser(),
    },
    // {
    //   title: "deposit_turnover", //add to ui core
    //   navigationUrl: "/deposit-turnover", //add route to ui core
    //   enabled: true,
    // },
    {
      title: "Promotions", //add to ui core
      navigationUrl: "/promotions", //add route to ui core
      enabled: true,
    },
    {
      title: UserMenuEnum.MY_TRANSACTION,
      navigationUrl: MY_TRANSACTION_ROUTE,
      enabled: domainConfig.payments && notDemoUser(),
    },
    {
      title: UserMenuEnum.STAKE_SETTINGS,
      navigationUrl: STAKE_SETTINGS_ROUTE,
      enabled: notDemoUser(),
    },
    {
      title: UserMenuEnum.MY_BET,
      navigationUrl: MY_BETS_ROUTE,
      enabled: true,
    },
    {
      title: "Change Password",
      navigationUrl: "/change-password",
      enabled: true,
    },
    {
      title: "Rules and Regulations",
      navigationUrl: "/rules",
      enabled: true,
    },
    {
      title: UserMenuEnum.SIGNOUT,
      navigationUrl: LOGIN_ROUTE,
      enabled: true,
    },
  ];
  const { langData } = useAppSelector((state) => state.cms);

  useEffect(() => {
    const selectedLang = sessionStorage.getItem("lang")
      ? sessionStorage.getItem("lang")
      : "en";
    dispatch(getLangData(selectedLang));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ToggleSkins = () => {
    return (
      <MenuComponent
        menuTitle={<img src={SkinIcon} className="h-5 w-5 shrink-0" alt="skins" />}
        menuList={<SkinOptions />}
        isOpen={isSkinOpen}
        closeMenu={() => setIsSkinOpen(false)}
        toggleMenu={() => setIsSkinOpen(!isSkinOpen)}
        customButtonCss="shrink-0"
      />
    );
  };

  const websiteUrls = getEnvVariable(domain, "skins") || [];

  const menuList = (
    <ul className="flex flex-col font-helvetica text-[11px]">
      <li className="p-2 text-black text-xs font-bold bg-goldenYellow">
        {getUsername()}
      </li>
      {userMenuList.map(
        ({ title, navigationUrl, enabled }, index) =>
          enabled && (
            <li
              key={index}
              className={`hover:underline cursor-pointer ${
                title === UserMenuEnum.SIGNOUT ? "" : "border-b border-b-gray18"
              }`}
            >
              {title === UserMenuEnum.SIGNOUT ? (
                <div
                  className="text-center bg-blue4 text-white py-2 font-bold text-xs"
                  onClick={() => {
                    dispatch(logout());
                    dispatch(
                      showToast({
                        type: "success",
                        message: "Logged out successfully",
                      }),
                    );
                  }}
                >
                  {langData?.["logout"]}
                </div>
              ) : (
                <div className="px-2 py-1">
                  <Link to={navigationUrl || ""} className="cursor-pointer">
                    {title}
                  </Link>
                </div>
              )}
            </li>
          ),
      )}
    </ul>
  );

  const handleWithdrawClick = () => {
    navigate(WITHDRAW_ROUTE);
  };

  const handleDepositClick = () => {
    navigate(DEPOSIT_ROUTE);
  };
  // useEffect(() => {
  //   // console.log('langsel1--->>>')
  //   if(langSelected !== undefined){
  //     // console.log('langsel2--->>>')
  //       sessionStorage.setItem("lang", langSelected);
  //       dispatch(getLangData(langSelected));
  //   }
  // }, [langSelected]);

  return (
    <div
      className={`flex flex-col flex-0 w-full ${
        isMobile && !hasInplayInPath ? "gap-[1px]" : ""
      }`}
    >
      <div
        className={`relative max-md:z-30 flex items-center justify-between p-2 md:p-2 ${headerGradient}`}
      >
        <div className="flex md:gap-3 items-center">
          <img
            src={getEnvVariable(domain, "logo")}
            alt="logo"
            className={`md:my-2 lg:my-0 cursor-pointer ${getEnvVariable(domain, "logoClassName") || 'h-[28px] md:h-[40px] lg:h-[53px]'}`}
            onClick={() => navigate(`${HOME_ROUTE}`)}
          />

          {loggedIn && (
            <div className="hidden md:block">
              <HeaderSearchInput
                searchValue={searchValue}
                setSearchValue={setSearchValue}
              />
            </div>
          )}
        </div>

        {loggedIn ? (
          <div className="flex gap-2 md:gap-1 items-center">
            {domainConfig?.payments && domainConfig.b2cEnabled && (
              <div className="flex justify-center">
                {getUsername() !== "Demo User" && (
                  <>
                    <Button
                      onClick={handleDepositClick}
                      className="flex gap-2 text-[10px] md:text-xs rounded items-center bg-[#008000] w-fit px-1 md:px-2 md:py-[5px] justify-center mx-1 border border-white"
                    >
                      <span className=" my-auto text-white">
                        {isMobile ? langData?.["d"] : langData?.["deposit"]}
                      </span>
                    </Button>

                    <Button
                      onClick={handleWithdrawClick}
                      className="flex gap-2 text-[10px] md:text-xs rounded items-center bg-[#FF0000] py-[2px] w-fit px-1 md:px-2 md:py-[5px] justify-center mx-1 border border-white"
                    >
                      <span className=" my-auto text-white">
                        {isMobile ? langData?.["w"] : langData?.["withdraw"]}
                      </span>
                    </Button>
                  </>
                )}
              </div>
            )}
            <div className="flex md:gap-1">
              <div className="flex flex-row-reverse md:flex-row items-center gap-1">
                {isDesktop ? (
                  <>
                    <div className="hidden md:flex items-center gap-2 rounded-md  px-3 py-1 text-[12px] bg-[rgba(255,255,255,.1)] shadow-[inset_0_2px_0_0_rgba(255,255,255,.3)]">
                      <span className="text-[#ffb600]">
                        {langData?.["main_balance"] ?? "Main Balance"}
                      </span>
                      <span className="font-bold text-[#ffb600]">
                        {((Number(balance) - Number(exposure)) / cFactor)?.toFixed(2)}
                      </span>
                      <span className="text-[#ffb600]">
                        {langData?.["exposure"] ?? "Exposure"}
                      </span>
                      <span
                        className="font-bold text-[#ffb600] cursor-pointer"
                        onClick={() => setShowOpenBets(true)}
                        onKeyDown={(e) =>
                          e.key === "Enter" && setShowOpenBets(true)
                        }
                        role="button"
                        tabIndex={0}
                      >
                        {Number(exposure / cFactor)?.toFixed(2)}
                      </span>
                      <span
                        className="h-4 w-px bg-amber-600 shrink-0"
                        aria-hidden
                      />
                      {/* <button
                        type="button"
                        onClick={() => dispatch(fetchBalance())}
                        className="p-0.5 text-[#ffb600] hover:text-amber-300"
                        aria-label="Refresh balance"
                      >
                        <RefreshCw className="h-4 w-4" />
                      </button> */}
                      <div
                        className="relative flex items-center"
                        onMouseEnter={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                      >
                        <button
                          type="button"
                          className="p-0.5 text-[#ffb600] hover:text-amber-300 cursor-pointer"
                          aria-label="Balance details"
                          onClick={() => setShowTooltip((v) => !v)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              setShowTooltip((v) => !v);
                            }
                          }}
                          role="button"
                          tabIndex={0}
                        >
                          <FaInfoCircle className="h-4 w-4" />
                        </button>
                        {showTooltip && (
                          <div className="absolute left-1/2 mt-2 w-auto max-w-[300px] p-2 bg-gray-800 text-white text-[12px] rounded shadow-lg transform -translate-x-1/2 z-50 overflow-hidden">
                            <div>
                              {langData?.["cashable"] ?? "Cashable"}: {cashableDisplay}
                            </div>
                            <div className="whitespace-nowrap">
                              {langData?.["non_cashable"] ?? "Non-cashable"}: {nonCashableDisplay}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="relative hidden md:flex gap-1">
                      <MenuComponent
                        menuList={menuList}
                        menuTitle={
                          <>
                            <FaUser />
                            <span>{getUsername()}</span>
                            <ChevronDown className="h-4 w-4 shrink-0" />
                          </>
                        }
                        customButtonCss="text-[#ffb600] rounded-md h-[30px] px-3 text-xs flex items-center gap-1 no-underline hover:no-underline bg-[rgba(255,255,255,.1)] shadow-[inset_0_2px_0_0_rgba(255,255,255,.3)]"
                        toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
                        isOpen={isMenuOpen}
                        closeMenu={closeMenu}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    
                    <div className="relative flex md:hidden">
                      <MenuComponent
                        menuList={menuList}
                        menuTitle={
                          <>
                            <FaUser />
                            <span className="truncate max-w-[80px]">
                              {getUsername()}
                            </span>
                          </>
                        }
                        customButtonCss="text-[#ffb600] rounded-md h-[32px] px-2 text-[10px] flex items-center gap-1 no-underline hover:no-underline bg-[rgba(255,255,255,.1)] shadow-[inset_0_2px_0_0_rgba(255,255,255,.3)]"
                        toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
                        isOpen={isMenuOpen}
                        closeMenu={closeMenu}
                      />
                    </div>
                    <div
                      className="md:hidden items-center gap-1.5 rounded-md px-2 py-1.5 text-[10px] bg-[rgba(255,255,255,.1)] shadow-[inset_0_2px_0_0_rgba(255,255,255,.3)]"
                      role="presentation"
                    >
                      <div className="flex gap-1">
                        <span className="text-[#ffb600]/80">
                          {langData?.["bal"] ?? "Bal"}:
                        </span>
                        <span className="font-bold text-[#ffb600]">
                          {((Number(balance) - Number(exposure)) / cFactor)?.toFixed(2)}
                        </span>
                      </div>
                      <div className="flex gap-1">
                        <span
                          className="text-[#ffb600]/80 cursor-pointer"
                          onClick={() => setShowOpenBets(true)}
                          onKeyDown={(e) =>
                            e.key === "Enter" && setShowOpenBets(true)
                          }
                          role="button"
                          tabIndex={0}
                        >
                          {langData?.["exp"] ?? "Exp"}
                        </span>
                        <span
                          className="font-bold text-[#ffb600] cursor-pointer"
                          onClick={() => setShowOpenBets(true)}
                          onKeyDown={(e) =>
                            e.key === "Enter" && setShowOpenBets(true)
                          }
                          role="button"
                          tabIndex={0}
                        >
                          {Number(exposure / cFactor)?.toFixed(2)}
                        </span>
                      </div>
                    </div>
                    <div
                      ref={mobileTooltipRef}
                      className="relative flex md:hidden items-center"
                    >
                      <button
                        type="button"
                        className="p-0.5 text-[#ffb600] hover:text-amber-300 cursor-pointer"
                        aria-label="Balance details"
                        onClick={() => setShowTooltip((v) => !v)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setShowTooltip((v) => !v);
                          }
                        }}
                        role="button"
                        tabIndex={0}
                      >
                        <FaInfoCircle className="h-4 w-4" />
                      </button>
                      {showTooltip && (
                        <div className="absolute left-1/2 mt-2 w-auto max-w-[300px] p-2 bg-gray-800 text-white text-[10px] rounded shadow-lg transform -translate-x-1/2 z-50 overflow-hidden">
                          <div>
                            {langData?.["cashable"] ?? "Cashable"}: {cashableDisplay}
                          </div>
                          <div className="whitespace-nowrap">
                            {langData?.["non_cashable"] ?? "Non-cashable"}: {nonCashableDisplay}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>

              {websiteUrls?.length > 0 ? ToggleSkins(): null}
            </div>
          </div>
        ) : (
          <div className="flex gap-1">
            <LoginButtons />
            <Languages
              langSelected={langSelected}
              setLangSelected={setLangSelected}
            />
          </div>
        )}
      </div>

      {pathName === `${HOME_ROUTE}` && isMobile && (
        <div className="md:hidden">
          <NewsAndPromotions />
        </div>
      )}

      <div className="relative z-10 w-screen overflow-visible hide-scrollbar bg-sub-header-gradient text-black max-md:hidden">
        <SubHeader disableSportsSubheader={disableSportsSubheader} />
      </div>
      <Modal
        isOpen={showOpenBets}
        onClose={() => {
          setShowOpenBets(false);
        }}
        title={langData?.["my_market"]}
        modalBg="bg-section-gradient"
      >
        <AllOpenBets setShowOpenBets={setShowOpenBets} />
      </Modal>
    </div>
  );
};
export default Header;
